import { FC } from "react";
import classNames from "classnames";

import { GridCountRange } from "@types";

import { TeaserRecord } from "@graphql/types/graphql";
import { CBTeaser } from "components/molecules/Teaser/CBTeaser";
import s from "./GridTeaser.module.scss";

interface Props {
  data: TeaserRecord;
  columnCount: GridCountRange;
  background?: boolean;
  hasHoverEffect: boolean;
  hasBorder: boolean;
}

export const GridTeaser: FC<Props> = ({
  data,
  columnCount,
  background,
  hasHoverEffect,
  hasBorder,
}) => {
  return (
    <div
      className={classNames(s.GridTeaser, {
        [s.GridWithBackground]: background,
        [s.DoubleGrid]: columnCount === "2",
        [s.TripleGrid]: columnCount === "3",
        [s.QuadtripleGrid]: columnCount === "4",
        [s.HasHoverEffect]: hasHoverEffect,
      })}
      key={data.id}
    >
      <CBTeaser {...data} hasBorder={hasBorder} />
    </div>
  );
};
